var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIKakao({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1558_45800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.528 2.59375C6.87177 2.59375 2.28906 6.21645 2.28906 10.6889C2.28906 13.5981 4.23177 16.1505 7.14744 17.5775C6.93339 18.3754 6.37231 20.4738 6.25879 20.9213C6.11933 21.4792 6.46312 21.4694 6.6869 21.3202C6.86204 21.2035 9.49231 19.4132 10.6274 18.6413C11.2437 18.7321 11.8793 18.7808 12.528 18.7808C18.1842 18.7808 22.7669 15.1581 22.7669 10.6856C22.7669 6.21321 18.1842 2.59375 12.528 2.59375Z",
    fill: "#371C1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1558_45800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4778,
    height: 18.8141,
    fill: "white",
    transform: "translate(2.28516 2.59375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIKakao);
export default __webpack_public_path__ + "static/media/i_kakao.f45bc9f45e58fe9c0a83c08aedf71e82.svg";
export { ForwardRef as ReactComponent };